import { useState } from 'react';

import toast from 'react-hot-toast';

import type { ModalChildrenProps } from '@bitstopco/bitstop-theme';
import { LoadingButton } from '@mui/lab';
import { Button, DialogActions, DialogContent, Divider, Typography } from '@mui/material';

import { usePostResetUserPasswordV2Mutation } from '@/store/api/services/users/users';

import type { User } from '@/types';

const UserResetPasswordV2 = ({ hide, props }: ModalChildrenProps) => {
  const user: Pick<User, 'id' | 'email'> = useState(props)[0];

  const [resetPassword, { isLoading }] = usePostResetUserPasswordV2Mutation();

  const handleSubmit = async () => {
    try {
      await resetPassword(user.id).unwrap();

      toast.success('Password reset email sent');
      hide();
    } catch {}
  };

  return (
    <>
      <DialogContent sx={{ my: 2 }} data-test="reset-user-password-v2-modal">
        <Typography>
          Send <b>{user?.email}</b> an email with a link to set a new password?
        </Typography>
        <Typography mt={1} variant="body2" color="text.secondary">
          Their current password keeps working until they set a new one.
        </Typography>
      </DialogContent>
      <Divider />
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button onClick={hide}>Cancel</Button>
        <LoadingButton
          variant="contained"
          loading={isLoading}
          onClick={handleSubmit}
          data-test="reset-user-password-v2-modal-submit-btn"
        >
          Send Reset Email
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default UserResetPasswordV2;
